import React, { Component } from 'react';
import { source } from 'react-aim';

import { dispatch } from '@rematch/core';

import LoadingComponent from '../../../common/LoadingComponent';
import InDesignResourcePane from "../ResourcesPane/InDesign";
import PracticeFlowResourcePane from '../ResourcesPane/PracticeFlow';
import CommunityFlowResourcePane from '../ResourcesPane/CommunityFlow';
import PracticeCommunitySwimLineCommanPane from '../ResourcesPane/PracticeCommunitySwimLineCommanPane'
import PublishedPackResourcePane from '../ResourcesPane/PublishedPack'
import SummaryView from '../ResourcesPane/SummaryView'

import '@zippytech/react-toolkit/Accordion/index.css';

class IndexResourcePane extends Component {

    constructor(props) {
        super(props);
        this.state = {
            transactionTime: 300,
            transitioinFunction: 'linear'
        }
    }
    componentWillMount() {
        dispatch.createPack.setValidationCheckFlag(false)
    }
    componentDidMount() {
        dispatch.organizationTab.getCurrentOrganizationData(this.props.selectedOrganisation.id)
    }
    // Practice flow Conditions
    // 1. Indesign
    // 2. PracticeFlow
    // 3. CommunityFlow
    // Comman Resources pane for below 3 components /////
    // 4. PracticeFlowActivity  : PracticeCommunitySwimLineCommanPane
    // 5. CommunityFlowActivity : PracticeCommunitySwimLineCommanPane
    // 6. SwimLineDetail : PracticeCommunitySwimLineCommanPane
    // 7. PublishedPack


    render() {
        return (
            this.props.loadingPack && this.props.arrangementPaneActiveButtonFlag !== 'Configure' ? <LoadingComponent active={this.props.loadingPack || this.props.loadingCloneActivity}
                message={this.props.arrangementPaneActiveButtonFlag === 'Define' ? "Fetching Playbook Data" :
                    this.props.arrangementPaneActiveButtonFlag === 'Configure' ? "Fetching Activities" :
                        this.props.arrangementPaneActiveButtonFlag === 'Sequence' ? "Fetching Activities" :
                            this.props.arrangementPaneActiveButtonFlag === 'Assign' ? " Fetching Communities" :
                                this.props.arrangementPaneActiveButtonFlag === 'Schedule' ? "Fetching Swimline View" :
                                    this.props.arrangementPaneActiveButtonFlag === 'Publish' ? "Fetching Summary" :
                                        " Fetching Playbook Data"} />
                : this.props.selectedPracticeLibrary && this.props.showResourecePaneFlag === "Indesign" ?
                    <InDesignResourcePane {...this.props} transactionTime={this.state.transactionTime} transitionFunction={this.state.transitioinFunction} />
                    : this.props.showResourecePaneFlag === "PracticeFlow" ?
                        <PracticeFlowResourcePane {...this.props} transactionTime={this.state.transactionTime} />
                        : this.props.showResourecePaneFlag === "CommunityFlow" ?
                            <CommunityFlowResourcePane {...this.props} transactionTime={this.state.transactionTime} />
                            : this.props.showResourecePaneFlag === "SummaryView" ?
                                <SummaryView {...this.props} transactionTime={this.state.transactionTime} user={this.props.user} />
                                : this.props.showResourecePaneFlag === "PracticeCommunitySwimLineCommanPane" ?
                                    <PracticeCommunitySwimLineCommanPane {...this.props} transactionTime={this.state.transactionTime} user={this.props.user} />
                                    : this.props.showResourecePaneFlag === "PublishedPack" ?
                                        <PublishedPackResourcePane {...this.props} transactionTime={this.state.transactionTime} /> : ""
        )
    }
}

export default IndexResourcePane;